<template>
    <div class="ag-theme-balham filter_button_group flex flex_column">
        <div class="filter_button flex">
            <md-button :class="isFilterApplied ? 'md-primary md-button-filter-filled' :'md-blank'" @click="showFilter">
                <i class="fa fa-filter"></i>
            </md-button>
        </div>
        <div class="clear_button flex" v-if="isFilterApplied">
            <md-button class="md-blank" @click="clearFilter">
                <i class="fa fa-times"></i>
            </md-button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        isFilterApplied: { type: Boolean },
    },
    methods: {
        showFilter() {
            this.$emit("show-filter");
        },
        clearFilter() {
            this.$emit("clear-filter");
        }
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/base_variables.scss";

.filter_button_group {
    position: absolute;
    width: 2.5rem;

    hr {
        height: 0;
        border: none;
        border-top: 1px solid;
        margin: 0 5px;
        z-index: 1;
    }

    &:hover hr {
        border-color: $accent-background-color-hover;
    }

    .filter_button {
        height: 40.5px;

        .md-button-filter-filled {
            border-bottom: none;
            border-bottom-left-radius: 0;
        }
    }

    .clear_button {
        height: 40.5px;

        .md-button {
            border-top: none;
            border-top-left-radius: 0;

            .md-button-content i.fa {
            }
        }
    }

    .md-button::v-deep {
        min-width: 100%;
        margin: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right: none;

        .md-ripple {
            padding: 0;

            .md-button-content i.fa {
                font-size: 1.5rem !important;
            }
        }
    }
}
</style>